<script>
const isDev = process.env.NODE_ENV === 'development';
const isProd = !isDev;

export default {
    methods: {
        getCdnPath() {
            return isDev ? '//cdn.agro-mp.com' : '//cdn.agrolink.com.ua';
        },
        getMainLogoPath() {
            return this.getCdnPath() + '/images/logo/agrolink-main-logo.png';
        },
        getMobileLogoPath() {
            return this.getCdnPath() + '/images/logo/agrolink-mobile-drawer-logo.svg';
        },
    },
}
</script>
